import {
  Box,
  Button,
  Flex,
  Image,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { useState } from 'react';
import { FaExchangeAlt } from 'react-icons/fa';
import ReplaceDriveModal from 'components/drive/ReplaceDriveModal';

const ReplaceComponentForSingle = ({
  mediaType,
  setselectedMediaUrls,
  selectedMediaUrls = [],
  onClose,
  setActiveStep,
  setFieldValue,
  selectedAdAccounts
}) => {
  const {
    isOpen: isReplaceModalOpen,
    onOpen: OnReplaceModalOpen,
    onClose: OnReplaceModalClose,
  } = useDisclosure();

  const [activePlacement, setActivePlacement] = useState(null);

  const handleReplaceImage = (placement) => {
    setActivePlacement(placement);
    OnReplaceModalOpen();
  };

  const handleImageSelectedFromReplaceDrive = (file) => {
    if (file && file.length > 0) {

        const newImageUrl = file[0];

        setselectedMediaUrls((prev) =>
            prev.map((item) =>
                item.placement === activePlacement
                    ? {
                        ...item,
                        url: newImageUrl?.url ? newImageUrl?.url : newImageUrl?.picture,
                        hash: newImageUrl?.creativeId,
                        mediaHash: newImageUrl?.hash,
                        source: newImageUrl?.source,
                    }
                    : item
            )
        );

        setFieldValue('creative.object_story_spec.link_data.image_hash', newImageUrl?.creativeId);
        setFieldValue('image_url', newImageUrl?.url ? newImageUrl?.url : newImageUrl?.picture,);
    }

    setActivePlacement(null);
    OnReplaceModalClose();
};


  return (
    <>
      <ReplaceDriveModal
        isDriveModalOpen={isReplaceModalOpen}
        selectedAdAccounts={selectedAdAccounts}
        onClose={OnReplaceModalClose}
        onSubmit={handleImageSelectedFromReplaceDrive}
        uploadPurpose="update"
        mediaType={mediaType}
      />

      <Box mt={6}>
        <Flex gap={6} justifyContent={'center'} p={4} wrap="wrap" maxH={'600px'} overflowY={'auto'}>
            {selectedMediaUrls?.map(({ placement, url, source, mediaType }) => {

                return(
                <Box
                    key={`${placement}`}
                    border="1px solid"
                    borderColor={'gray.100'}
                    borderRadius="md"
                    p={2}
                    width={'240px'}
                    height={
                    placement === 'square'
                        ? '300px'
                        : placement === 'vertical'
                        ? '530px'
                        : '230px'
                    }
                    display="flex"
                    flexDirection="column"
                    gap={2}
                >
                    <Text fontWeight="bold" textTransform="capitalize">
                        {placement}
                    </Text>
                    {source ? (
                        <Box
                        width="220px"
                        height={
                            placement === 'square'
                            ? '200px'
                            : placement === 'vertical'
                                ? '440px'
                                : '120px'
                        }
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        bg="gray.200"
                        borderRadius="md"
                        >
                        <Box
                            as="video"
                            controls
                            src={source}
                            maxWidth="100%"
                            maxHeight="100%"
                            style={{ objectFit: 'contain', objectPosition: 'center' }}
                        />
                    </Box>
                    ) : (
                    <Box
                        width="220px"
                        height={
                        placement === 'square'
                            ? '200px'
                            : placement === 'vertical'
                            ? '430px'
                            : '120px'
                        }
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        bg="gray.200"               
                        borderRadius="md"
                    >
                        <Image
                            src={url}
                            alt={placement}
                            maxWidth="100%"
                            maxHeight="100%"
                            objectFit="contain"      
                            objectPosition="center"  
                        />
                    </Box>
                    )}
                    <Flex>
                    <Button
                        size="sm"
                        variant={'solid'}
                        colorScheme={'gray'}
                        mt={2}
                        leftIcon={<FaExchangeAlt />}
                        onClick={() => handleReplaceImage(placement, mediaType)}
                    >
                        Replace
                    </Button>
                    </Flex>
                </Box>
            )})}
        </Flex>
        <Flex gap={2} justifyContent={'flex-end'} mt={2}>
            <Button variant={'solid'} colorScheme='gray' onClick={onClose} size={'sm'}>
                Close
            </Button>
            <Button
                colorScheme={'brand'}
                size={'sm'}
                  onClick={() => {
                      onClose();
                      setActiveStep('Media');
                  }
                }
            >Done</Button>
        </Flex>
      </Box>
    </>
  );
};

export default ReplaceComponentForSingle;
